import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import logger from 'redux-logger'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import createRootReducer from '@/duck'

const persistConfig = {
    key: 'arctic',
    storage,
    whitelist: []
}

export default function configureStore(history, sagaMiddleware) {
    const persistedReducer = persistReducer(persistConfig, createRootReducer(history))
    const store = createStore(
        persistedReducer,
        compose(
            applyMiddleware(
                logger,
                routerMiddleware(history),
                sagaMiddleware
            ),
        ),
    )
    const persistor = persistStore(store)
    return { store, persistor }
}